import React, { useState, useEffect } from "react";
import { useNavigate,useParams} from 'react-router-dom';
import { Formik, Form } from "formik";
import Input from "../input";
import DropdownComp from "../dropdown";
import { api } from '../../api';
import { EditSupportSchema } from '../../validation/ValidationSchema';
import ButtonContained from '../button';
import { useSelector } from "react-redux";
import { toast } from "react-toastify";


import { getMerchants } from '../../helpers/listsApi';
import usePasswordToggle from '../hooks/usePasswordToggle';
const EditSupport = (props) => {
  const token = useSelector((state) => state.auth.token);
  // eslint-disable-next-line
  const { userType: role } = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const [merchants,setMerchants] = useState([]);
  const [adminData, setAdminData] = useState({});
  const [PwdInputType, ToggleIcon] = usePasswordToggle();


  const { id: adminId } = useParams(); 


    useEffect(()=>{
        getMerchants(false,token).then(dt=>{
            setMerchants(dt)
        })
    },[token])

    useEffect(() => {
      api.users
          .getUserByID({ usersId: adminId },token)
          .then((res) => {
              if (res.success === false) {
                  toast.error(res.message);
              }
              setAdminData(res.user)
          })
          .catch((err) => {
              toast.error("Something went wrong");
              console.log(err)
          }
          );
  }, [adminId,token])

    const status = [
      {value: true, label: "Active"},
      {value: false, label: "Inactive"}
    ]
  
  const getCurrentStatus = (value, list) => {
    const currentValue = list.find(lst => lst.value === value)
    return currentValue
  }

  const getMerchantsData = (value, list) => {
    const currentMerchantsList = [];
    const stringData= String(value);
    const splidata = stringData.split(',');

    for(var i=0 ; i< splidata.length ; i++) {
      for(var j=0 ; j<list.length ; j++) {
        // eslint-disable-next-line
        if(splidata[i] == list[j].value) {
          currentMerchantsList.push(list[j])
        }
      }
    }
    return currentMerchantsList;
  }

  const merchantUpdate = (value) => {
    const finalValue = [];
    value.map(item =>  {
      return finalValue.push(item.value);
    })
    return finalValue.join();
  }

  return (
    // <Modal
    //   modalHeader="Edit Customer Support"
    //   showModal={adminModel}
    //   closeModal={closeModal}
    //   buttonText="SAVE"
    // >
      <Formik
        enableReinitialize
        validationSchema={EditSupportSchema}
        initialValues={{
          usersUserName: adminData.usersUserName,
          usersUserType: adminData.usersUserType,
          usersPhone: adminData.usersPhone,
          usersEmail: adminData.usersEmail,
          usersName: adminData.usersName,
          merchants: adminData.merchants,
          usersPassword: adminData.usersPassword,
          confpassword: adminData.usersPassword,
          usersMerchentIds: getMerchantsData(adminData.usersMerchentIds, merchants),
          usersStatus: getCurrentStatus(adminData.usersStatus, status),
          is2faEnabled: adminData?.is2faEnabled ?? true,
        }}
        onSubmit={(values, actions) => {
          const formBody = {
            usersId: adminId,
            usersUserName: values.usersUserName,
            usersUserType: adminData.usersUserType,
            usersPhone: values.usersPhone,
            usersEmail: values.usersEmail,
            usersName: values.usersName,
            usersBrand: values.usersBrand,
            usersStatus: values.usersStatus.value,
            usersPassword: values.usersPassword,
            usersMerchentIds: merchantUpdate(values.usersMerchentIds),
            is2faEnabled: values.is2faEnabled
          };
          api.users.update(formBody,token).then(res => {
            if (res.success === false) {
              toast.error(res.message);
            } else {
              toast.success(res.message);
              navigate('/customer-support')
            }
          })
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          isValid,
          errors,
          isSubmitting,
          setFieldValue,
        }) => {
          return (
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12">
                  <div className="box-row">

                    <div className="table-head">
                      <h1 className="sec-header">EDIT SUPPORT</h1>
                  </div>

                    <div className="card card-table">
                      {/* <div className="card-header card-header-title">Support Details</div> */}
                      <div className="card-body gatepass-saveoutput">
                        <div className="reports agents">
                          <Form noValidate validated={!isValid} onSubmit={handleSubmit}>
                            <div className="form-row">
                              <div className="form-group col-md-4">
                                <Input
                                  id="usersUserName"
                                  name="usersUserName"
                                  placeholder="User Name"
                                  type="text"
                                  label="User Name"
                                  value={values.usersName}
                                  onChange={handleChange}
                                  error={touched.usersUserName && errors.usersUserName}
                                  errorText={errors.usersUserName}
                                  disabled={true} />
                              </div>
                              <div className="form-group col-md-4">
                                <Input
                                  id="usersEmail"
                                  name="usersEmail"
                                  placeholder="Email Id"
                                  label="Email"
                                  value={values.usersEmail}
                                  onChange={handleChange}
                                  error={touched.usersEmail && errors.usersEmail}
                                  errorText={errors.usersEmail}
                                  disabled={true} />
                              </div>
                              <div className="form-group col-md-4">
                                <Input
                                  id="usersPhone"
                                  name="usersPhone"
                                  placeholder="Phone Number"
                                  type="number"
                                  label="Phone"
                                  value={values.usersPhone}
                                  onChange={handleChange}
                                  error={touched.usersPhone && errors.usersPhone}
                                  errorText={errors.usersPhone}
                                  disabled={isSubmitting} />
                              </div>
                            </div>

                            <div className="form-row">
                             
                              <div className="form-group col-md-4">
                                <Input
                                  id="usersName"
                                  name="usersName"
                                  placeholder="Support Name"
                                  label="Support Name"
                                  value={values.usersName}
                                  onChange={handleChange}
                                  error={touched.usersName && errors.usersName}
                                  errorText={errors.usersName}
                                  disabled={isSubmitting} />
                              </div>
                              <div className="form-group col-md-4">
                                <DropdownComp
                                  isMulti
                                  id="merchants"
                                  name="usersMerchentIds"
                                  onChange={(selectedValue) => {
                                      setFieldValue('usersMerchentIds', selectedValue)
                                  }}
                                  value={values.usersMerchentIds}
                                  options={merchants}
                                  label="Merchants"
                                  placeholder="Please select"
                                  error={touched.usersMerchentIds && errors.usersMerchentIds}
                                  errorText={errors.usersMerchentIds}
                                  disabled={isSubmitting} />
                              </div>
                              <div className="form-group col-md-4">
                                <DropdownComp
                                  id="usersStatus"
                                  name="usersStatus"
                                  onChange={(selectedValue) => {
                                    setFieldValue("usersStatus", selectedValue)
                                  }}
                                  value={values.usersStatus}
                                  options={status}
                                  label="Status"
                                  placeholder="Status"
                                  error={touched.usersStatus && errors.usersStatus}
                                  errorText={errors.usersStatus}
                                  disabled={isSubmitting} />
                              </div>
                            </div>

                            <div className="form-row">
                              <div className="form-group col-md-4">
                                <Input
                                  id="usersPassword"
                                  name="usersPassword"
                                  placeholder="Password"
                                  type={PwdInputType}
                                  autoComplete="usersPassword"
                                  onPaste={true}
                                  label="Enter New Password"
                                  value={values.usersPassword}
                                  onChange={handleChange}
                                  error={touched.usersPassword && errors.usersPassword}
                                  errorText={errors.usersPassword}
                                  disabled={isSubmitting} 
                                  isToggle={ values.usersPassword ? true: false }
                                  toggleIcon={ ToggleIcon }/>
                              </div>
                              <div className="form-group col-md-4">
                                <Input
                                  id="confpassword"
                                  name="confpassword"
                                  type="password"
                                  placeholder="Confirm Password"
                                  autoComplete="confpassword"
                                  label="Confirm Password"
                                  onPaste={true}
                                  value={values.confpassword}
                                  onChange={handleChange}
                                  error={touched.confpassword && errors.confpassword}
                                  errorText={errors.confpassword}
                                  disabled={isSubmitting} />
                              </div>


                                  <div className="form-group col-md-4">
                                  <label htmlFor="is2faEnabled" className="d-block mb-2">
                                      Enable 2FA
                                  </label>
                                  <div className="custom-control custom-switch">
                                      <input
                                          type="checkbox"
                                          className="custom-control-input"
                                          id="is2faEnabled"
                                          name="is2faEnabled"
                                          checked={values.is2faEnabled}
                                          onChange={(e) => setFieldValue("is2faEnabled", e.target.checked)}
                                          disabled={isSubmitting}
                                      />
                                      <label className="custom-control-label" htmlFor="is2faEnabled">
                                          {values.is2faEnabled ? "Enabled" : "Disabled"}
                                      </label>
                                  </div>
                              </div>

                              
                            </div>
                            <ButtonContained buttonName="Update"
                              disabled={isSubmitting} />
                          </Form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }}
      </Formik>
    // </Modal>
  );
};
export default EditSupport;
